interface LevelIconProps {
  level: number;
  color?: string;
  fontColor?: string;
  fontClassName?: string;
}

export const LevelIcon = ({
  level = 1,
  color = '#F3D260',
  fontColor = '#000',
  fontClassName
}: LevelIconProps) => {
  return (
    <div
      className={fontClassName}
      style={{ position: 'relative', height: 26, width: 26, cursor: 'default' }}
    >
      <span
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          fontSize: 14,
          fontWeight: 500,
          transform: 'translate(-50%, -50%)',
          display: 'inline-block',
          color: fontColor
        }}
      >
        {level}
      </span>
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.6438 1.65171C11.8064 1.44835 12.0129 1.28419 12.2477 1.17138C12.4823 1.05857 12.7396 1 13 1C13.2605 1 13.5177 1.05857 13.7524 1.17138C13.9871 1.28419 14.1936 1.44835 14.3562 1.65171L15.9682 3.65785C16.151 3.88532 16.3883 4.06307 16.6579 4.17465C16.9276 4.28624 17.2211 4.32809 17.5112 4.29631L20.0694 4.01777C20.3276 3.99024 20.5888 4.02092 20.8336 4.10754C21.0786 4.19416 21.3009 4.33453 21.4844 4.51834C21.6679 4.70215 21.8079 4.92473 21.8942 5.16974C21.9805 5.41475 22.0106 5.67597 21.9828 5.93419L21.7042 8.49116C21.6726 8.78135 21.7147 9.07482 21.8264 9.34448C21.9382 9.61415 22.1161 9.85131 22.3437 10.0341L24.3489 11.6449C24.552 11.8077 24.7161 12.0141 24.8287 12.2488C24.9415 12.4836 25 12.7407 25 13.001C25 13.2615 24.9415 13.5185 24.8287 13.7533C24.7161 13.988 24.552 14.1944 24.3489 14.3573L22.3437 15.9691C22.1161 16.1516 21.9382 16.3886 21.8264 16.6581C21.7147 16.9276 21.6726 17.2209 21.7042 17.5109L21.9828 20.069C22.011 20.3274 21.9808 20.5889 21.8945 20.8342C21.8083 21.0793 21.668 21.3021 21.4842 21.4859C21.3003 21.6698 21.0776 21.81 20.8324 21.8962C20.5871 21.9825 20.3256 22.0126 20.0673 21.9844L17.5091 21.7058C17.2189 21.6745 16.9255 21.7166 16.6558 21.8283C16.3862 21.9402 16.149 22.1179 15.9661 22.3453L14.3562 24.3483C14.1936 24.5516 13.9871 24.7159 13.7524 24.8286C13.5177 24.9415 13.2605 25 13 25C12.7396 25 12.4823 24.9415 12.2477 24.8286C12.0129 24.7159 11.8064 24.5516 11.6438 24.3483L10.0339 22.3432C9.851 22.1158 9.61381 21.9381 9.34417 21.8262C9.07453 21.7145 8.7811 21.6724 8.49091 21.7037L5.93277 21.9823C5.67434 22.0105 5.41286 21.9804 5.16762 21.8941C4.92237 21.8079 4.69962 21.6677 4.51579 21.4838C4.33196 21.3 4.19174 21.0773 4.10546 20.8321C4.01918 20.5868 3.98906 20.3253 4.0173 20.0669L4.29585 17.5088C4.32741 17.2188 4.28536 16.9255 4.17359 16.6561C4.06181 16.3865 3.8839 16.1495 3.65631 15.967L1.65112 14.3573C1.44792 14.1944 1.28391 13.988 1.17121 13.7533C1.05851 13.5185 1 13.2615 1 13.001C1 12.7407 1.05851 12.4836 1.17121 12.2488C1.28391 12.0141 1.44792 11.8077 1.65112 11.6449L3.65631 10.0341C3.88392 9.85131 4.06181 9.61415 4.17359 9.34448C4.28535 9.07482 4.3274 8.78135 4.29585 8.49116L4.0173 5.93419C3.98929 5.67577 4.01957 5.41435 4.10591 5.16918C4.19225 4.924 4.33247 4.70129 4.51622 4.51744C4.69998 4.33359 4.92262 4.19327 5.16776 4.10679C5.41291 4.02033 5.67431 3.9899 5.93277 4.01777L8.49091 4.29631C8.78104 4.32809 9.0745 4.28624 9.34418 4.17465C9.61386 4.06307 9.85109 3.88532 10.0339 3.65785L11.6438 1.65171Z"
          fill={color}
          stroke="white"
          strokeWidth="0.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
